import {
    LOAD_EXERCISES,
    SET_ERROR,
    SET_EXERCISES,
    STATUS_UNINITIALIZED,
    STATUS_LOADING,
    STATUS_LOADED,
    STATUS_ERROR,
} from "../Exercises";
import { LOGOUT } from "../Auth";

const initialState = { loadStatus : STATUS_UNINITIALIZED, list : [], map : {} }

export default function(state=initialState, action) {
    switch(action.type) {
        case LOAD_EXERCISES: {
            return { ...initialState, loadStatus: STATUS_LOADING }
        }
        case SET_ERROR : {
            return { ...initialState, loadStatus : STATUS_ERROR, error : action.payload }
        }
        case SET_EXERCISES : {
            const map = {}
            action.payload.forEach(exercise => {
                map[exercise.id] = exercise
            })
            return { loadStatus : STATUS_LOADED, list : action.payload, map : map }
        }
        case LOGOUT : {
            return initialState
        }
        default:
            return state
    }
}
